import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { ACCOUNT_SETTINGS_PAGES } from '../../routeConfiguration';
import { propTypes } from '../../util/types';
import {
    ExternalLink,
    InlineTextButton,
    Logo,
    Menu,
    MenuContent,
    MenuItem,
    MenuLabel,
    NamedLink,
} from '../../components';

import css from './TopbarDesktop.css';

const TopbarDesktop = props => {
    const {
        className,
        currentUser,
        currentPage,
        rootClassName,
        currentUserHasListings,
        notificationCount,
        intl,
        isAuthenticated,
        onLogout,
        theme,
        onSearchSubmit,
        initialSearchFormValues,
    } = props;

    const classes = classNames(rootClassName || css.root, className);

    const notificationDot = notificationCount > 0 ? <div className={css.notificationDot} /> : null;

    const currentPageClass = page => {
        const isAccountSettingsPage =
            page === 'AccountSettingsPage' && ACCOUNT_SETTINGS_PAGES.includes(currentPage);
        return currentPage === page || isAccountSettingsPage ? css.currentPage : null;
    };

    const profileMenu = isAuthenticated ? (
        <Menu>
            <MenuLabel className={css.profileMenuLabel} isOpenClassName={css.profileMenuIsOpen}>
                {notificationDot}
            </MenuLabel>
            <MenuContent className={css.profileMenuContent}>
                <MenuItem key="YourListingsPage">
                    <NamedLink
                        className={classNames(
                            css.yourListingsLink,
                            currentPageClass('YourListingsPage')
                        )}
                        name="YourListingsPage"
                    >
                        <span className={css.menuItemBorder} />
                        <FormattedMessage id="TopbarDesktop.yourListingsLink" />
                    </NamedLink>
                </MenuItem>
                {/* Name link */}
                <MenuItem key="ManageListingsPage">
                    <NamedLink
                        className={classNames(
                            css.yourListingsLink,
                            currentPageClass('YourListingsPage')
                        )}
                        name="NewListingPage"
                    >
                        <span className={css.menuItemBorder} />
                        <FormattedMessage id="TopbarMobileMenu.newStoryLink" />
                    </NamedLink>
                </MenuItem>

                <MenuItem key="ProfileSettingsPage">
                    <NamedLink
                        className={classNames(
                            css.profileSettingsLink,
                            currentPageClass('MyNatureProfileSettingsPage')
                        )}
                        name="MyNatureProfileSettingsPage"
                    >
                        <span className={css.menuItemBorder} />
                        <FormattedMessage id="TopbarDesktop.profileSettingsLink" />
                    </NamedLink>
                </MenuItem>

                <MenuItem key="logout">
                    <InlineTextButton rootClassName={css.logoutButton} onClick={onLogout}>
                        <span className={css.menuItemBorder} />
                        <FormattedMessage id="TopbarDesktop.logout" />
                    </InlineTextButton>
                </MenuItem>
            </MenuContent>
        </Menu>
    ) : null;

    const signupLink = isAuthenticated ? null : (
        <NamedLink name="SignupPage" className={css.signupLink}>
            <span className={css.signup}>
                <FormattedMessage id="TopbarDesktop.signup" />
            </span>
        </NamedLink>
    );

    const homeLink = (
        <NamedLink name="LandingPage" className={css.staticLinks}>
            <span className={css.login}>
                <FormattedMessage id="TopbarDesktop.home" />
            </span>
        </NamedLink>
    );

    const people = (
        <NamedLink name="Personas" className={css.staticLinks}>
            <span className={css.login}>
                <FormattedMessage id="TopbarDesktop.people" />
            </span>
        </NamedLink>
    );

    const business = (
        <NamedLink name="BusinessPage" className={css.staticLinks}>
            <span className={css.login}>
                <FormattedMessage id="TopbarDesktop.bussiness" />
            </span>
        </NamedLink>
    );

    const guardianesAliados = (
        <NamedLink name="AlliesPage" className={css.staticLinks}>
            <span className={css.login}>
                <FormattedMessage id="TopbarDesktop.allies" />
            </span>
        </NamedLink>
    );

    const blog = (
        <ExternalLink className={css.staticLinks} href="https://medium.com/regenera">
            <span className={css.login}>
                <FormattedMessage id="TopbarDesktop.blog" />
            </span>
        </ExternalLink>
    );

    const loginLink = isAuthenticated ? null : (
        <NamedLink name="LoginPage" className={css.loginLink}>
            <span className={css.login}>
                <FormattedMessage id="TopbarDesktop.login" />
            </span>
        </NamedLink>
    );

    return (
        <nav className={`${classes} ${theme === 'dark' ? css.dark : ''}`}>
            <NamedLink className={css.logoLink} name="LandingPage">
                <Logo
                    format={theme === 'light' ? 'desktop' : 'mobile'}
                    className={css.logo}
                    alt={intl.formatMessage({ id: 'TopbarDesktop.logo' })}
                />
            </NamedLink>
            {/*search*/}
            {/*
        <NamedLink className={css.createListingLink} name="NewListingPage">
          <span className={css.createListing}>
            <FormattedMessage id="TopbarDesktop.createListing" />
          </span>
        </NamedLink>
      */}
            <div className={css.navigationItems}>
                {homeLink}
                {people}
                {business}
                {guardianesAliados}
                {profileMenu}
                {loginLink}
                {signupLink}
            </div>
        </nav>
    );
};

const { bool, func, object, number, string } = PropTypes;

TopbarDesktop.defaultProps = {
    theme: 'light',
    rootClassName: null,
    className: null,
    currentUser: null,
    currentPage: null,
    notificationCount: 0,
    initialSearchFormValues: {},
};

TopbarDesktop.propTypes = {
    rootClassName: string,
    className: string,
    currentUserHasListings: bool.isRequired,
    currentUser: propTypes.currentUser,
    currentPage: string,
    isAuthenticated: bool.isRequired,
    onLogout: func.isRequired,
    notificationCount: number,
    onSearchSubmit: func.isRequired,
    initialSearchFormValues: object,
    intl: PropTypes.object.isRequired,
};

export default TopbarDesktop;
